import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lxj: null,
		loading: false,
	},
	getters: {},
	mutations: {
		setLoading(state, loading) {
			state.loading = loading
		},
		set(state, lxj) {
			state.lxj = lxj
		},
	},
	actions: {
		async find({ commit, dispatch }) {
			commit("setLoading", true)
			await this._vm.$axios
				.get("/OryxPlace/OryxplaceParameters/Find")
				.then(response => {
					const data = Utils.ValidateAxiosResponse(response.data)
					commit("set", data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
				.finally(() => {
					commit("setLoading", false)
				})
		},
		async insert({ state, dispatch }){

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/OryxPlace/OryxplaceParameters/Insert", state.lxj )
			.then(async response => {
				Utils.ValidateAxiosResponse(response.data);
				await dispatch("find")
				return true
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update({ state, dispatch }){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/OryxPlace/OryxplaceParameters/Update", state.lxj )
			.then(async response => {
				Utils.ValidateAxiosResponse(response.data);
				await dispatch("find")
				return true
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete({ dispatch }){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete("/OryxPlace/OryxplaceParameters/Delete")
			.then(async response => {
				Utils.ValidateAxiosResponse(response.data);
				await dispatch("find")
				return true
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
	},
}
